// "use client";
// import React from "react";
// import { Box, Typography, Container } from "@mui/material";
// import { useTranslation } from "react-i18next";

// const stats = [
//   {
//     id: 1,
//     valueKey: "numbersStats.stat1Value",
//     titleKey: "numbersStats.stat1Title",
//     descKey: "numbersStats.stat1Desc",
//   },
//   {
//     id: 2,
//     valueKey: "numbersStats.stat2Value",
//     titleKey: "numbersStats.stat2Title",
//     descKey: "numbersStats.stat2Desc",
//   },
//   {
//     id: 3,
//     valueKey: "numbersStats.stat3Value",
//     titleKey: "numbersStats.stat3Title",
//     descKey: "numbersStats.stat3Desc",
//   },
//   {
//     id: 4,
//     valueKey: "numbersStats.stat4Value",
//     titleKey: "numbersStats.stat4Title",
//     descKey: "numbersStats.stat4Desc",
//   },
//   {
//     id: 5,
//     valueKey: "numbersStats.stat5Value",
//     titleKey: "numbersStats.stat5Title",
//     descKey: "numbersStats.stat5Desc",
//   },
// ];

// const NumbersStats = () => {
//   const { t, i18n } = useTranslation();
//   const isArabic = i18n.language === "ar";

//   return (
//     <Box
//       sx={{
//         backgroundColor: "#ffffff",
//         py: { xs: 5, sm: 6, md: 8 },
//         direction: isArabic ? "rtl" : "ltr",
//         mb: "1.4%",
//       }}
//     >
//       <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 3 } }}>
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             textAlign: "center",
//           }}
//         >
//           {/* ── EYEBROW PILL ── */}
//           <Box
//             sx={{
//               backgroundColor: "#F3F0FF",
//               borderRadius: "50px",
//               px: 2,
//               py: 0.8,
//               mb: { xs: 2, sm: 2.5 },
//               border: "1px solid #C4B5FD",
//             }}
//           >
//             <Typography
//               sx={{
//                 fontFamily: "var(--font-outfit)",
//                 fontWeight: 400,
//                 fontSize: { xs: "0.7rem", sm: "1rem" },
//                 color: "#6D28D9",
//               }}
//             >
//               {t("numbersStats.eyebrow")}
//             </Typography>
//           </Box>

//           {/* ── HEADING ── */}
//           <Typography
//             sx={{
//               fontFamily: "var(--font-plusjakarta)",
//               fontWeight: 800,
//               fontSize: { xs: "1.5rem", sm: "2rem", md: "3rem" },
//               color: "#0F0A1E",
//               lineHeight: 1.25,
//               letterSpacing: "-0.01em",
//               mb: { xs: 4, sm: 5, md: 6 },
//               px: { xs: 1, sm: 2, md: 0 },
//             }}
//           >
//             {t("numbersStats.heading")}
//           </Typography>

//           {/* ── STAT CARDS ── */}
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: { xs: "column", md: "row" },
//               gap: { xs: 2, sm: 2.5, md: 2.5 },
//               width: "100%",
//             }}
//           >
//             {stats.map((stat) => (
//               <Box
//                 key={stat.id}
//                 sx={{
//                   position: "relative",
//                   flex: 1,
//                   backgroundColor: "#ffffff",
//                   borderRadius: "14px",
//                   overflow: "hidden",
//                   boxShadow:
//                     "0 1px 3px rgba(15, 23, 42, 0.06), 0 1px 12px rgba(15, 23, 42, 0.04)",
//                   textAlign: isArabic ? "right" : "left",
//                   p: { xs: 2.5, sm: 2.5 },
//                   border: "1px solid #EFE8FB",
//                 }}
//               >
//                 {/* top accent bar */}
//                 <Box
//                   sx={{
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                     width: "100%",
//                     height: "4px",
//                     background:
//                       "linear-gradient(90deg, #6D28D9 0%, #A855F7 100%)",
//                   }}
//                 />

//                 <Typography
//                   sx={{
//                     fontFamily: "var(--font-plusjakarta)",
//                     fontWeight: 800,
//                     fontSize: { xs: "1.6rem", sm: "2rem" },
//                     color: "#6D28D9",
//                     mb: 1.3,
//                   }}
//                 >
//                   {t(stat.valueKey)}
//                 </Typography>
//                 <Box
//                   sx={{
//                     width: 32,
//                     height: 2,
//                     backgroundColor: "#6D28D9",
//                     borderRadius: "2px",
//                     mb: 1.8,
//                     opacity: 0.4,
//                   }}
//                 />
//                 <Typography
//                   sx={{
//                     fontFamily: "var(--font-outfit)",
//                     fontWeight: 600,
//                     fontSize: { xs: "0.85rem", sm: "1.05rem" },
//                     color: "#1A0A3C",
//                     lineHeight: 1.4,
//                     mb: 1,
//                   }}
//                 >
//                   {t(stat.titleKey)}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontFamily: "var(--font-outfit)",
//                     fontSize: { xs: "0.72rem", sm: "0.9rem" },
//                     color: "#6B7280",
//                     lineHeight: 1.5,
//                   }}
//                 >
//                   {t(stat.descKey)}
//                 </Typography>
//               </Box>
//             ))}
//           </Box>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default NumbersStats;

"use client";
import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Container } from "@mui/material";
import { useTranslation } from "react-i18next";

// arSuffix  = Arabic mein number ke BAAD aane wala text  (e.g. "%" , "x" , "ساعة")
// arPrefix  = Arabic mein number ke PEHLE aane wala text (e.g. "+")
// suffix    = English mein number ke baad (e.g. "%", "hrs", "x", "+")
const stats = [
  {
    id: 1,
    endValue: 83,
    suffix: "%",
    arSuffix: "%",
    arPrefix: "",
    valueKey: "numbersStats.stat1Value",
    titleKey: "numbersStats.stat1Title",
    descKey: "numbersStats.stat1Desc",
  },
  {
    id: 2,
    endValue: 23,
    suffix: "hrs",
    arSuffix: " ساعة",
    arPrefix: "",
    valueKey: "numbersStats.stat2Value",
    titleKey: "numbersStats.stat2Title",
    descKey: "numbersStats.stat2Desc",
  },
  {
    id: 3,
    endValue: 8,
    suffix: "x",
    arSuffix: "x",
    arPrefix: "",
    valueKey: "numbersStats.stat3Value",
    titleKey: "numbersStats.stat3Title",
    descKey: "numbersStats.stat3Desc",
  },
  {
    id: 4,
    endValue: 87,
    suffix: "%",
    arSuffix: "%",
    arPrefix: "",
    valueKey: "numbersStats.stat4Value",
    titleKey: "numbersStats.stat4Title",
    descKey: "numbersStats.stat4Desc",
  },
  {
    id: 5,
    endValue: 50,
    suffix: "+",
    arSuffix: "+",
    arPrefix: "",
    valueKey: "numbersStats.stat5Value",
    titleKey: "numbersStats.stat5Title",
    descKey: "numbersStats.stat5Desc",
  },
];

// ── Counter Hook ──────────────────────────────────────────────
function useCountUp(end, duration = 1800, startFrom = 1) {
  const [count, setCount] = useState(startFrom);
  const [triggered, setTriggered] = useState(false);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!triggered) return;

    let startTime = null;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      // ease-out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(startFrom + (end - startFrom) * eased));
      if (progress < 1) {
        rafRef.current = requestAnimationFrame(step);
      }
    };

    rafRef.current = requestAnimationFrame(step);

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [triggered, end, duration, startFrom]);

  const trigger = () => setTriggered(true);
  return { count, trigger };
}

// ── Single Stat Card ──────────────────────────────────────────
const StatCard = ({ stat }) => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const cardRef = useRef(null);
  const { count, trigger } = useCountUp(stat.endValue);
  const hasTriggered = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasTriggered.current) {
          hasTriggered.current = true;
          trigger();
          observer.disconnect();
        }
      },
      { threshold: 0.3 },
    );

    if (cardRef.current) observer.observe(cardRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <Box
      ref={cardRef}
      sx={{
        position: "relative",
        flex: 1,
        backgroundColor: "#ffffff",
        borderRadius: "14px",
        overflow: "hidden",
        boxShadow:
          "0 1px 3px rgba(15, 23, 42, 0.06), 0 1px 12px rgba(15, 23, 42, 0.04)",
        textAlign: isArabic ? "right" : "left",
        p: { xs: 2.5, sm: 2.5 },
        border: "1px solid #EFE8FB",
      }}
    >
      {/* top accent bar */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "4px",
          background: "linear-gradient(90deg, #6D28D9 0%, #A855F7 100%)",
        }}
      />

      {/* Animated counter value */}
      <Typography
        sx={{
          fontFamily: "var(--font-plusjakarta)",
          fontWeight: 800,
          fontSize: { xs: "1.6rem", sm: "2rem" },
          color: "#6D28D9",
          mb: 1.3,
          direction: "ltr",
          unicodeBidi: "plaintext",
        }}
      >
        {isArabic
          ? `${stat.arPrefix}${count}${stat.arSuffix}`
          : `${count}${stat.suffix}`}
      </Typography>

      <Box
        sx={{
          width: 32,
          height: 2,
          backgroundColor: "#6D28D9",
          borderRadius: "2px",
          mb: 1.8,
          opacity: 0.4,
        }}
      />

      <Typography
        sx={{
          fontFamily: "var(--font-outfit)",
          fontWeight: 600,
          fontSize: { xs: "0.85rem", sm: "1.05rem" },
          color: "#1A0A3C",
          lineHeight: 1.4,
          mb: 1,
        }}
      >
        {t(stat.titleKey)}
      </Typography>

      <Typography
        sx={{
          fontFamily: "var(--font-outfit)",
          fontSize: { xs: "0.72rem", sm: "0.9rem" },
          color: "#6B7280",
          lineHeight: 1.5,
        }}
      >
        {t(stat.descKey)}
      </Typography>
    </Box>
  );
};

// ── Main Component ────────────────────────────────────────────
const NumbersStats = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",
        py: { xs: 3, sm: 6, md: 8 },
        direction: isArabic ? "rtl" : "ltr",
        mb: "1.4%",
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 3 } }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {/* ── EYEBROW PILL ── */}
          <Box
            sx={{
              backgroundColor: "#F3F0FF",
              borderRadius: "50px",
              px: 2,
              py: 0.8,
              mb: { xs: 2, sm: 2.5 },
              border: "1px solid #C4B5FD",
            }}
          >
            <Typography
              sx={{
                fontFamily: "var(--font-outfit)",
                fontWeight: 400,
                fontSize: { xs: "0.7rem", sm: "1rem" },
                color: "#6D28D9",
              }}
            >
              {t("numbersStats.eyebrow")}
            </Typography>
          </Box>

          {/* ── HEADING ── */}
          <Typography
            sx={{
              fontFamily: "var(--font-plusjakarta)",
              fontWeight: 800,
              fontSize: { xs: "1.5rem", sm: "2rem", md: "3rem" },
              color: "#0F0A1E",
              lineHeight: 1.25,
              letterSpacing: "-0.01em",
              mb: { xs: 4, sm: 5, md: 6 },
              px: { xs: 1, sm: 2, md: 0 },
            }}
          >
            {t("numbersStats.heading")}
          </Typography>

          {/* ── STAT CARDS ── */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 2, sm: 2.5, md: 2.5 },
              width: "100%",
            }}
          >
            {stats.map((stat) => (
              <StatCard key={stat.id} stat={stat} />
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default NumbersStats;
